class PersonalizationDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.currentSlide = 1;
    this.personalizationData = null;
    this.overlay = this.querySelector('.personalization-drawer__overlay');
    this.drawer = this.querySelector('.personalization-drawer__inner');
    this.slides = this.querySelectorAll('.personalization-drawer__slide');
    
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.close();
      });
    }
    
    if (this.drawer) {
      this.drawer.addEventListener('click', (e) => {
        const colorOption = e.target.closest('.personalization-drawer__color-option');
        if (colorOption) {
          const allColorOptions = this.querySelectorAll('.personalization-drawer__color-option');
          allColorOptions.forEach(option => {
            option.classList.remove('personalization-drawer__color-option--selected');
          });
          
          colorOption.classList.add('personalization-drawer__color-option--selected');
          
          if (this.currentSlide === 4) {
            this.hideError();
          }
          
          return;
        }
        
        e.stopPropagation();
      });
    }
    
    const initialsInput = this.querySelector('#personalization-initials');
    if (initialsInput) {
      initialsInput.addEventListener('input', () => {
        this.formatInitials(initialsInput);
        if (this.currentSlide === 2 && initialsInput.value.trim() !== '') {
          this.hideError();
        }
      });
    }
    
    this.addEventListener('change', (e) => {
      if (e.target.name === 'font' && this.currentSlide === 3) {
        this.hideError();
      }
      if (e.target.name === 'position' && this.currentSlide === 5) {
        this.hideError();
      }
    });
  }
  
  open() {
    this.isOpen = true;
    this.currentSlide = 1;
    this.showSlide(1);
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    
    if (this.personalizationData) {
      this.restorePersonalizationData();
    } else {
    this.clearAllSelections();
    }
    
    const firstFocusable = this.drawer?.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }
  
  formatInitials(input) {
    const MAX_INITIALS = 3;
    const previous = input.dataset.formatted || '';
    let letters = (input.value.match(/[a-zA-Z]/g) || []).join('').toUpperCase();

    if (letters === (previous.match(/[A-Z]/g) || []).join('') && input.value.length < previous.length) {
      letters = letters.slice(0, -1);
    }

    letters = letters.slice(0, MAX_INITIALS);

    const formatted = letters ? letters.split('').join('.') + '.' : '';
    input.dataset.formatted = formatted;

    if (input.value !== formatted) {
      input.value = formatted;
      input.setSelectionRange(formatted.length, formatted.length);
    }
  }

  restorePersonalizationData() {
    if (!this.personalizationData) return;
    
    const initialsInput = this.querySelector('#personalization-initials');
    if (initialsInput && this.personalizationData.initials) {
      initialsInput.value = this.personalizationData.initials;
      this.formatInitials(initialsInput);
    }
    
    const fontRadio = this.querySelector(`input[name="font"][value="${this.personalizationData.font}"]`);
    if (fontRadio) {
      fontRadio.checked = true;
    }
    
    const colorOption = this.querySelector(`.personalization-drawer__color-option[data-color="${this.personalizationData.color}"]`);
    if (colorOption) {
      colorOption.classList.add('personalization-drawer__color-option--selected');
    }
    
    const positionRadio = this.querySelector(`input[name="position"][value="${this.personalizationData.position}"]`);
    if (positionRadio) {
      positionRadio.checked = true;
    }
  }
  
  clearAllSelections() {
    const initialsInput = this.querySelector('#personalization-initials');
    if (initialsInput) {
      initialsInput.value = '';
      initialsInput.dataset.formatted = '';
    }
    
    const fontRadios = this.querySelectorAll('input[name="font"]');
    fontRadios.forEach(radio => {
      radio.checked = false;
    });
    
    const colorOptions = this.querySelectorAll('.personalization-drawer__color-option');
    colorOptions.forEach(option => {
      option.classList.remove('personalization-drawer__color-option--selected');
    });
    
    const positionRadios = this.querySelectorAll('input[name="position"]');
    positionRadios.forEach(radio => {
      radio.checked = false;
    });
    
    this.hideError();
  }
  
  close() {
    this.isOpen = false;
    this.removeAttribute('open');
    document.body.style.overflow = '';
    this.currentSlide = 1;
    this.showSlide(1);
    
    if (!this.personalizationData) {
    this.clearAllSelections();
    }
    
    this.dispatchEvent(new CustomEvent('drawer-closed', { bubbles: true }));
  }
  
  showSlide(slideNumber) {
    this.hideError();
    
    this.slides.forEach((slide, index) => {
      if (index + 1 === slideNumber) {
        slide.classList.add('personalization-drawer__slide--active');
        
        const title = slide.getAttribute('data-title');
        const subtitle = slide.getAttribute('data-subtitle');
        const titleElement = this.querySelector('[data-slide-title]');
        const subtitleElement = this.querySelector('[data-slide-subtitle]');
        
        if (title && titleElement) {
          if (subtitle) {
            titleElement.innerHTML = title + ' <br><span class="personalization-drawer__subtitle">' + subtitle + '</span>';
          } else {
            titleElement.textContent = title;
          }
        } else if (slideNumber === 1) {
          if (titleElement) {
            titleElement.innerHTML = 'Personalizza la camicia <br><span class="personalization-drawer__subtitle">Perché ricamare?</span>';
          }
        }
      } else {
        slide.classList.remove('personalization-drawer__slide--active');
      }
    });
    this.currentSlide = slideNumber;
    this.updateProgressIndicator(slideNumber);
  }
  
  updateProgressIndicator(activeSlide) {
    const progressIndicator = this.querySelector('[data-progress-indicator]');
    if (!progressIndicator) return;
    
    if (activeSlide === 1) {
      progressIndicator.style.display = 'none';
      return;
    } else {
      progressIndicator.style.display = 'flex';
    }
    
    const activeStep = activeSlide - 1;
    
    const progressSteps = progressIndicator.querySelectorAll('[data-step]');
    progressSteps.forEach((step) => {
      const stepNumber = parseInt(step.getAttribute('data-step'));
      step.classList.remove('personalization-drawer__progress-step--active', 'personalization-drawer__progress-step--completed');
      
      if (stepNumber < activeStep) {
        step.classList.add('personalization-drawer__progress-step--completed');
      } else if (stepNumber === activeStep) {
        step.classList.add('personalization-drawer__progress-step--active');
      }
    });
  }
  
  goToStep(stepNumber) {
    if (stepNumber >= 1 && stepNumber <= this.slides.length) {
      this.showSlide(stepNumber);
    }
  }
  
  validateCurrentSlide() {
    const currentSlideElement = this.slides[this.currentSlide - 1];
    if (!currentSlideElement) return true;
    
    if (this.currentSlide === 2) {
      const initialsInput = this.querySelector('#personalization-initials');
      if (!initialsInput || !initialsInput.value || initialsInput.value.trim() === '') {
        this.showError('Per favore, inserisci le iniziali (massimo 3 lettere)');
        return false;
      }
    }
    
    if (this.currentSlide === 3) {
      const fontSelected = this.querySelector('input[name="font"]:checked');
      if (!fontSelected) {
        this.showError('Per favore, seleziona un carattere');
        return false;
      }
    }
    
    if (this.currentSlide === 4) {
      const colorSelected = this.querySelector('.personalization-drawer__color-option--selected');
      if (!colorSelected) {
        this.showError('Per favore, seleziona un colore del ricamo');
        return false;
      }
    }
    
    if (this.currentSlide === 5) {
      const positionSelected = this.querySelector('input[name="position"]:checked');
      if (!positionSelected) {
        this.showError('Per favore, seleziona una posizione');
        return false;
      }
    }
    
    this.hideError();
    return true;
  }
  
  showError(message) {
    this.hideError(); 
    
    const currentSlideElement = this.slides[this.currentSlide - 1];
    if (!currentSlideElement) return;
    
    const errorElement = document.createElement('div');
    errorElement.className = 'personalization-drawer__error-message';
    errorElement.textContent = message;
    errorElement.setAttribute('role', 'alert');
    errorElement.setAttribute('aria-live', 'polite');
    
    const slideContent = currentSlideElement.querySelector('.personalization-drawer__slide-content');
    if (slideContent) {
      slideContent.insertBefore(errorElement, slideContent.firstChild);
    }
  }
  
  hideError() {
    const errorElement = this.querySelector('.personalization-drawer__error-message');
    if (errorElement) {
      errorElement.remove();
    }
  }
  
  nextSlide() {
    if (!this.validateCurrentSlide()) {
      return;
    }
    
    if (this.currentSlide < this.slides.length) {
      this.showSlide(this.currentSlide + 1);
    }
  }
  
  previousSlide() {
    if (this.currentSlide > 1) {
      this.showSlide(this.currentSlide - 1);
    }
  }
  
  confirmPersonalization() {
    const initials = this.querySelector('#personalization-initials')?.value.trim() || '';
    const font = this.querySelector('input[name="font"]:checked')?.value || '';
    const color = this.querySelector('.personalization-drawer__color-option--selected')?.getAttribute('data-color') || '';
    const position = this.querySelector('input[name="position"]:checked')?.value || '';
    
    if (!initials || initials.trim() === '') {
      this.showError('Per favore, inserisci le iniziali (massimo 3 lettere)');
      return;
    }
    
    if (!font) {
      this.showError('Per favore, seleziona un carattere');
      return;
    }
    
    if (!color) {
      this.showError('Per favore, seleziona un colore del ricamo');
      return;
    }
    
    if (!position) {
      this.showError('Per favore, seleziona una posizione');
      return;
    }
    
    this.personalizationData = {
      initials: initials,
      font: font,
      color: color,
      position: position
    };
    
    this.hideError();
    this.close();
    
    this.updatePersonalizationButton();
    
    this.addCustomizedPropertyToProductForm();
  }
  
  updatePersonalizationButton() {
    const buttonText = document.getElementById('personalization-button-text');
    if (buttonText && this.personalizationData && this.personalizationData.initials) {
      const initials = this.personalizationData.initials.toUpperCase();
      buttonText.textContent = `personalizza la camicia (${initials})`;
    }
  }
  
  getPersonalizationData() {
    return this.personalizationData;
  }
  
  clearPersonalizationData() {
    this.personalizationData = null;
    this.removeCustomizedPropertyFromProductForm();
  }
  
  hasPersonalization() {
    return this.personalizationData !== null;
  }
  
  addCustomizedPropertyToProductForm() {
    if (!this.personalizationData) return;

    const formSelectors = [
      'form[action="/cart/add"]',
      'form[action*="/cart/add"]',
      'form[data-product-form]',
      'form[data-product]'
    ];

    const forms = document.querySelectorAll(formSelectors.join(', '));
    if (!forms || forms.length === 0) return;

    forms.forEach((form) => {
      const inputName = 'properties[Customized]';
      let hiddenInput = form.querySelector(`input[name="${inputName}"]`);
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = inputName;
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = 'Yes';
    });
  }

  removeCustomizedPropertyFromProductForm() {
    const formSelectors = [
      'form[action="/cart/add"]',
      'form[action*="/cart/add"]',
      'form[data-product-form]',
      'form[data-product]'
    ];

    const forms = document.querySelectorAll(formSelectors.join(', '));
    if (!forms || forms.length === 0) return;

    forms.forEach((form) => {
      const inputName = 'properties[Customized]';
      const hiddenInput = form.querySelector(`input[name="${inputName}"]`);
      if (hiddenInput) {
        hiddenInput.remove();
      }
    });
  }

  connectedCallback() {
    if (this.personalizationData) {
      this.updatePersonalizationButton();
      this.addCustomizedPropertyToProductForm();
    }
  }
}

customElements.define('personalization-drawer', PersonalizationDrawer);
